import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  layerStyles: {
    cardCarrera: {
      bg: "white",
      p: 6,
      borderRadius: "xl",
      boxShadow: "sm",
      transition: "all 0.2s",
      color: "gray.800",
      _hover: { 
        transform: "translateY(-4px)", 
        boxShadow: "lg" 
      },
    },
    searchBar: {
      bg: "white",
      p: 6,
      borderRadius: "2xl",
      boxShadow: "xl",
    },
    cardInstitucion: {
      bg: "white",
      p: 0, 
      borderRadius: "2xl",
      boxShadow: "lg",
      transition: "all 0.3s ease",
      color: "gray.800",
      overflow: "hidden", 
      _hover: { 
        transform: "translateY(-6px)", 
        boxShadow: "2xl" 
      },
    },
    filterSidebar: {
      bg: "white",
      p: 6,
      borderRadius: "xl",
      position: "sticky",
      top: "20px",
    }
  },
  components: {
    Button: {
      variants: {
        action: {
          borderRadius: "full",
          size: "sm",
          variant: "outline",
          colorScheme: "blue",
        },
        search: {
          size: "lg",
          colorScheme: "blue",
          px: 10,
          boxShadow: "0 4px 14px 0 rgba(0,118,255,0.39)",
        }
      }
    }
  },
  cardHomeDestacada: {
    bg: "white",
    p: 5,
    borderRadius: "xl",
    boxShadow: "md",
    color: "gray.800",
    cursor: "pointer",
    transition: "all 0.3s ease",
    _hover: { 
      transform: "translateX(8px)", // Animación lateral en lugar de hacia arriba
      boxShadow: "xl",
      bg: "blue.50" 
    },
  },
  calendarCard: {
    bg: "whiteAlpha.200",
    backdropFilter: "blur(10px)",
    borderRadius: "2xl",
    p: 6,
    border: "1px solid",
    borderColor: "whiteAlpha.300",
    transition: "all 0.3s ease",
    _hover: {
      bg: "whiteAlpha.300",
      transform: "translateY(-5px)",
      borderColor: "yellow.400", 
    },
  },
  footerBar: {
    bg: "rgba(0, 0, 0, 0.2)",
    backdropFilter: "blur(10px)",
    borderTop: "1px solid",
    borderColor: "whiteAlpha.200",
    color: "white",
  },
});

export default theme;